import { render, staticRenderFns } from "./sdjn2.vue?vue&type=template&id=25bd3c4c&"
import script from "./sdjn2.vue?vue&type=script&lang=js&"
export * from "./sdjn2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports